/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type GetApiSentSmsListSortBy = typeof GetApiSentSmsListSortBy[keyof typeof GetApiSentSmsListSortBy] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiSentSmsListSortBy = {
  sentAt: 'sentAt',
  recipient: 'recipient',
  sender: 'sender',
  departmentName: 'departmentName',
} as const;
